export const SLOW_BACKEND_CALL_THRESHOLD_MS = 1000;
